export enum DataState {
  Idle = 'Idle',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Fulfilled = 'Fulfilled',
}
